/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_LinkInputs */

const en_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const id_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebijakan Privasi`)
};

const ms_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasar Privasi`)
};

const ca_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacitat`)
};

const cs_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zásady ochrany osobních údajů`)
};

const da_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatlivspolitik`)
};

const de_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzerklärung`)
};

const et_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`privaatsuspoliitika`)
};

const es_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidad`)
};

const fr_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique de confidentialité`)
};

const hr_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pravilnik o privatnosti`)
};

const it_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informativa sulla privacy`)
};

const lv_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privātuma politika`)
};

const lt_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatumo politika`)
};

const hu_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adatvédelmi szabályzat`)
};

const nl_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacybeleid`)
};

const nb_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personvernerklæring`)
};

const pl_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polityka prywatności`)
};

const pt_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidade`)
};

const ro_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politica de Confidențialitate`)
};

const sk_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zásady ochrany osobných údajov`)
};

const sl_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zasebnost`)
};

const fi_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietosuojakäytäntö`)
};

const sv_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integritetspolicy`)
};

const vi_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chính sách quyền riêng tư`)
};

const tr_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gizlilik Politikası`)
};

const el_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πολιτική απορρήτου`)
};

const bg_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика за поверителност`)
};

const ru_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика конфиденциальности`)
};

const sr_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смернице за приватност`)
};

const uk_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Політика конфіденційності`)
};

const ka_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`კონფიდენციალურობის პოლიტიკა`)
};

const hi_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गोपनीयता नीति`)
};

const th_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นโยบายสความเป็นส่วนตัว`)
};

const ko_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개인정보 보호정책`)
};

const zh_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐私政策`)
};

const zh_tw_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隱私政策`)
};

const ja_privacy_policy_link = /** @type {(inputs: Privacy_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライバシーポリシー`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Privacy_Policy_LinkInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_policy_link = /** @type {((inputs?: Privacy_Policy_LinkInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_LinkInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_policy_link(inputs)
	if (locale === "ms") return ms_privacy_policy_link(inputs)
	if (locale === "ca") return ca_privacy_policy_link(inputs)
	if (locale === "cs") return cs_privacy_policy_link(inputs)
	if (locale === "da") return da_privacy_policy_link(inputs)
	if (locale === "de") return de_privacy_policy_link(inputs)
	if (locale === "et") return et_privacy_policy_link(inputs)
	if (locale === "es") return es_privacy_policy_link(inputs)
	if (locale === "fr") return fr_privacy_policy_link(inputs)
	if (locale === "hr") return hr_privacy_policy_link(inputs)
	if (locale === "it") return it_privacy_policy_link(inputs)
	if (locale === "lv") return lv_privacy_policy_link(inputs)
	if (locale === "lt") return lt_privacy_policy_link(inputs)
	if (locale === "hu") return hu_privacy_policy_link(inputs)
	if (locale === "nl") return nl_privacy_policy_link(inputs)
	if (locale === "nb") return nb_privacy_policy_link(inputs)
	if (locale === "pl") return pl_privacy_policy_link(inputs)
	if (locale === "pt") return pt_privacy_policy_link(inputs)
	if (locale === "ro") return ro_privacy_policy_link(inputs)
	if (locale === "sk") return sk_privacy_policy_link(inputs)
	if (locale === "sl") return sl_privacy_policy_link(inputs)
	if (locale === "fi") return fi_privacy_policy_link(inputs)
	if (locale === "sv") return sv_privacy_policy_link(inputs)
	if (locale === "vi") return vi_privacy_policy_link(inputs)
	if (locale === "tr") return tr_privacy_policy_link(inputs)
	if (locale === "el") return el_privacy_policy_link(inputs)
	if (locale === "bg") return bg_privacy_policy_link(inputs)
	if (locale === "ru") return ru_privacy_policy_link(inputs)
	if (locale === "sr") return sr_privacy_policy_link(inputs)
	if (locale === "uk") return uk_privacy_policy_link(inputs)
	if (locale === "ka") return ka_privacy_policy_link(inputs)
	if (locale === "hi") return hi_privacy_policy_link(inputs)
	if (locale === "th") return th_privacy_policy_link(inputs)
	if (locale === "ko") return ko_privacy_policy_link(inputs)
	if (locale === "zh") return zh_privacy_policy_link(inputs)
	if (locale === "zh-tw") return zh_tw_privacy_policy_link(inputs)
	if (locale === "ja") return ja_privacy_policy_link(inputs)
	return en_privacy_policy_link(inputs)
});